import * as React from "react";
import { Card, HTMLTable } from "@blueprintjs/core";
import { InfoTooltip } from "../info-tooltip";

export const MetadataCardsWrapper = ({ children }: { children?: React.ReactNode }) => {
  return <div className="metadata-cards-wrapper">{children}</div>;
};

export const MetadataCard = ({
  title,
  className = "",
  children,
  right,
}: {
  children?: React.ReactNode;
  className?: string;
  title: React.ReactNode;
  right?: React.ReactNode;
}) => {
  return (
    <Card className={`${className} metadata-card`} elevation={1}>
      <HTMLTable bordered={false} interactive={false} className="metadata-card__table">
        <thead>
          <tr>
            <th colSpan={2}>
              <div className="metadata-card__table__header">
                <div className="metadata-card__table__header__title">{title}</div>
                <div className="metadata-card__table__header__right">{right}</div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>{children}</tbody>
      </HTMLTable>
    </Card>
  );
};

export const MetadataRow = ({
  label,
  value,
  info,
  onValueClick,
  wrapText = false,
}: {
  label: React.ReactNode;
  value: React.ReactNode;
  info?: string;
  onValueClick?: () => void;
  wrapText?: boolean;
}) => {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  return (
    <tr>
      <td className="metadata-card__key">
        {label}
        {info ? <InfoTooltip>{info}</InfoTooltip> : null}
      </td>
      <td
        onClick={onValueClick}
        className={`metadata-card__value${onValueClick ? " hoverable clickable" : ""}${
          wrapText ? " wrap-text" : ""
        }`}
      >
        {value}
      </td>
    </tr>
  );
};

export const MetadataVerticalCards = ({ children }: { children?: React.ReactNode }) => {
  return <div className="metadata-vertical-cards">{children}</div>;
};
